import styled from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const ModalContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 95%;
  max-width: 1000px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 32px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: color 0.2s;

  &:hover {
    color: #1a1a1a;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 32px;
  padding: 32px;
  flex: 1;
  overflow-y: auto;
`;

export const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RightPanel = styled.div`
  width: 250px;
  padding: 20px;
  background-color: #f5f5f7;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ToggleLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ToggleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const ToggleStatus = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const ToggleDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`;

export const SectionHeader = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
`;

export const ScheduleOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FrequencyRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FrequencyLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const DropdownWrapper = styled.div`
  width: 340px;
`;

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 8px 0;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: #666;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 32px;
  border-top: 1px solid #e0e0e0;
`;

